
import 'vue-select/dist/vue-select.css';
import RegisterService, {
  RegisterRequest
} from '../services/FormService'
// const vSelect  = require('vue-select')
import Mixin from '../mixin'

import {mixins, Options,Watch} from 'vue-property-decorator'
import {ENV} from "@/apps/rever-academy/components/Constant";
import CourseService from "@/apps/rever-academy/services/CourseService";
import Course from "@/apps/rever-academy/domain/Course";
import { useVuelidate } from '@vuelidate/core'
import { required,numeric,email,helpers } from '@vuelidate/validators'
const $ = require('jquery')
const COURSE_CLASSES = ENV.VUE_APP_COURSE_CLASS.split(';')
//import "vue-select/dist/vue-select.css";
const checkName = helpers.regex(/^\D+$/)
import { defineComponent} from 'vue';


export default defineComponent({
  name: "RegisterForm",
  setup() {
    return { v$: useVuelidate() };
  },
  data(){
    return{
      formData: new RegisterRequest(),
      submitted: false,
      submitting: false,
      error: null,
      options: []
    }
  },
  validations() {
    return {
      formData: {
        firstname: {required, checkName},
        lastname: {required, checkName},
        phone: {required, numeric},
        email: {required, email},
        class: {required}
      }
    }
  },
  mounted() {
    $(window).on('keydown', (e: any) => {
      const {
        keyCode
      } = e
      const ESC_KEY = 27

      if (keyCode === ESC_KEY) {
        this.hide()
      }
    })
    this.retrieveCourseOptions(null)
  },
  computed:{
    successTitle() {
      return ENV.VUE_APP_REGISTER_SUCCESS_TITLE
    },

    formApi() {
      return ENV.VUE_APP_FORM_API
    },

    popup(): JQuery {
      return $('#register_form.bg-overlay').find('.popup')
    },

    bgOverlay() {
      return $("#register_form.bg-overlay")
    },

    academyEmail() {
      return ENV.VUE_APP_ACADEMY_EMAIL
    },

    context() {
      return {
        page_url: location.href,
        page_name: document.title
      }
    }
  },
  methods:{
    // dropdownShouldOpen(VueSelect: any) {
    //   return VueSelect.search.length !== 0
    // }


    // get datetimepickerInput() {
    //   return this.$refs && this.$refs.datetimepickerInput
    // }
    //
    // datetimepickerFocus() {
    //   if (this.$refs)
    //     (this.$refs.datetimepickerInput as InstanceType<typeof Datetimepicker>).focus()
    // }



    // setup () {
    //   return {
    //     v$: useVuelidate()
    //   }
    // }




    show(e: Event, data: any) {
      this.formData = {
        ...this.formData,
        ...data
      }

      setTimeout(() => {
        console.log("show1")
        this.popup.removeClass('animationClose').addClass('animationOpen')

      }, 100)
      $("#register_form.bg-overlay").fadeIn(50)

      e.preventDefault()
    },


    hide() {
      if (this.submitting) return
      setTimeout(() => {
        $("#register_form.bg-overlay").fadeOut(350);
      }, 50)
      this.popup.removeClass('animationOpen').addClass('animationClose')
      $(this.$el).find('.form').find('.error.active').removeClass('active')
      this.reset()
    },

    reset() {
      if (this.submitted) {
        this.formData = new RegisterRequest()
      }
      this.submitted = false
      this.submitting = false
      this.error = null
      this.v$.$reset()
      // this.bgOverlay.css("display","none");
    },

   retrieveCourseOptions(event: Event | null) {
      //console.log(keyword);

      setTimeout(() => {
        const value = (event) ? (event.target as HTMLInputElement).value : ''
        CourseService.getOptionsByName(value)

            .then((res) => {
              this.options = res.data.data;
              console.log(this.options);
            })
            .catch((err) => {
              console.log(err.response.data);
            });
      }, 300) ;

    },

    checkEmptyField(str: string) {
      const rex = new RegExp("^\\s+$")
      return rex.test(str)
    },

    checkPhone(str: string) {
      const rex = new RegExp("^\\d{10,14}$")
      return rex.test(str)
    },

    checkName(str: string) {
      const rex = new RegExp("\\d+")
      return !rex.test(str)
    },

    validateField(key: string) {
      console.log(key)
      // setTimeout(() => {
      //   if (!this.formData[key] || this.checkEmptyField(this.formData[key]) || (Array.isArray(this.formData[key]) && this.formData[key].length === 0)) {
      //     $(this.$el).find(`[name=${key}]`).parent().find('.error').addClass('active')
      //   } else if ((key === 'phone') && !this.checkPhone(this.formData[key])) {
      //     $(this.$el).find(`[name=${key}]`).parent().find('.error').addClass('active')
      //   } else if ((key === 'firstname' || key === 'lastname') && !this.checkName(this.formData[key])) {
      //     $(this.$el).find(`[name=${key}]`).parent().find('.error').addClass('active')
      //   } else {
      //     $(this.$el).find(`[name=${key}]`).parent().find('.error.active').removeClass('active')
      //   }
      // }, 300)
      if(this.v$.formData === undefined || this.v$.formData === null)
        return false
      else return this.v$.formData[key].$error
    },


    async submit() {
      const result = await this.v$.$validate()
      console.log(this.v$)
      // if ()
      console.log(`${process.env.contact_from_api}/${process.env.id_submit_form}`)
      if (result) {
        this.submitting = true
        console.log(this.formData)
        this.formData.class = this.formData.class.map((course) => course.value)
        const ser: any = {
          data: []
        }
        Object.keys(this.formData).forEach(key => {

          if (Array.isArray(this.formData[key])) {
            this.formData[key].forEach(item => {
              ser.data.push({
                param: key,
                value: item
              })
            })
          } else {
            ser.data.push({
              param: key,
              value: this.formData[key]
            })
          }
        })
        ser.context = this.context
        RegisterService.submit(ser)
            .then((res) => {
              this.submitted = true

            }).catch((error) => {
          this.error = error

        }).then(() => {
          this.submitting = false
        })
      }


    }

  }
})
